import React, { useEffect, useState, useRef } from 'react';
import ToolCard from './ToolCard';
import './ToolCard.css';
import { usePagination } from '../context/PaginationContext';
import axios from 'axios';

const ToolList = ({ filter, category, setCategory, searchQuery }) => {
  const { currentPage, setCurrentPage, tools, setTools, refreshTools } = usePagination();
  const toolsPerPage = 12;

  const [loading, setLoading] = useState(true);
  const [availableCategories, setAvailableCategories] = useState([]);

  const hasFetched = useRef(false);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        if (tools.length === 0) {
          await refreshTools();
        }
      } catch (err) {
        console.error('Failed to fetch tools:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTools();
  }, [tools, setTools]);

  // Reset pagination and scroll when filter/category changes
  useEffect(() => {
    setCurrentPage(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [filter, category]);

  // Filter by Free/Paid
  let filteredTools = tools;
  if (filter === 'free') filteredTools = tools.filter((tool) => tool.isFree);
  if (filter === 'paid') filteredTools = tools.filter((tool) => !tool.isFree);

  // Update category list
  useEffect(() => {
    if (filter) {
      const cats = [
        ...new Set(filteredTools.map((tool) => tool.category).filter(Boolean)),
      ];
      setAvailableCategories(cats);
    } else {
      setAvailableCategories([]);
    }
  }, [filter, tools]);

  // Filter by selected category
  if (category) {
    filteredTools = filteredTools.filter(
      (tool) =>
        (tool.category || '').toLowerCase() === category.toLowerCase()
    );
  }

  // **New: Filter by searchQuery**
  if (searchQuery && searchQuery.trim() !== '') {
    const lowerQuery = searchQuery.toLowerCase();
    filteredTools = filteredTools.filter(
      (tool) =>
        (tool.name || '').toLowerCase().includes(lowerQuery) ||
        (tool.category || '').toLowerCase().includes(lowerQuery)
    );
  }

  const startIndex = (currentPage - 1) * toolsPerPage;
  const currentTools = filteredTools.slice(
    startIndex,
    startIndex + toolsPerPage
  );
  const totalPages = Math.ceil(filteredTools.length / toolsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  // ...keep all imports and existing code above unchanged

return (
  <div style={{ padding: '1.5rem' }}>
    <h2 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
      🔥 Explore AI Tools
    </h2>

    {filter && availableCategories.length > 0 && (
      <div className="category-box">
        <div className="categories-scroll">
          {availableCategories.map((cat, index) => (
            <span
              key={index}
              onClick={() =>
                setCategory((prev) => (prev === cat ? null : cat))
              }
              className={
                category === cat ? 'active-category' : 'category-item'
              }
            >
              {cat}
            </span>
          ))}
        </div>
      </div>
    )}

    {loading ? (
      <p style={{ textAlign: 'center', color: '#888' }}>Loading tools...</p>
    ) : (
      <div className="tool-list-container">
        {currentTools.length > 0 ? (
          currentTools.map((tool, index) => (
            <ToolCard key={index} tool={tool} />
          ))
        ) : searchQuery && searchQuery.trim() !== '' ? (
          <p style={{ textAlign: 'center', color: '#888' }}>
            No tools found for "{searchQuery}"
          </p>
        ) : (
          <p style={{ textAlign: 'center', color: '#888' }}>
            No tools found for selected filters.
          </p>
        )}
      </div>
    )}

    {!loading && filteredTools.length > toolsPerPage && (
      <div className="pagination-container">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className={`pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
        >
          ❮ Prev
        </button>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`pagination-btn ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
        >
          Next ❯
        </button>
      </div>
    )}
  </div>
);

};

export default ToolList;
